import { render, staticRenderFns } from "./ProccessList.vue?vue&type=template&id=6a1b6668"
import script from "./ProccessList.js?vue&type=script&lang=js&external"
export * from "./ProccessList.js?vue&type=script&lang=js&external"
import style0 from "./ProccessList.vue?vue&type=style&index=0&id=6a1b6668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports